module.exports = __webpack_public_path__ + "static/media/impedance-mockup.5c3c61cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/Iteq/assets/impedance-mockup.jpg
// module id = 2705
// module chunks = 0